<template lang="pug">
	.list-control
		input.form-control.form-control-sm(v-for="(value, index) in list" :type="setting.type" :value="value" :placeholder="setting.options.placeholder" v-on:change="Settings.setListSettingValue(setting.codename, $event.target.value, index)")
		input.form-control.form-control-sm(:type="setting.type" v-model="newValue" :placeholder="list.length > 0 ? 'put additional url here...' : setting.options.placeholder" v-on:change="addNewValue")
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';

	export default {
		name: "ListControl",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['setting'],
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.list = [];

			return {
				showed: true,
				newValue: ''
			}

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии креатива
			this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.codename}`);

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('ListControl collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				//console.log('collectData', this.setting.codename, this.setting);

				this.list = Settings.getSettingValue(this.setting.codename);

			},
			addNewValue() {

				Settings.setListSettingValue(this.setting.codename, this.newValue);

				this.newValue = '';

			}
		}
	}
</script>

<style lang="sass">

	.list-control
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column


</style>
